import {assertValue} from '@/shared/assertValue';

export const siteUrl = assertValue(
	process.env.NEXT_PUBLIC_SITE_URL,
	'Missing environment variable: NEXT_PUBLIC_SITE_URL',
);
